import { TABS } from './tabs';
export const FEATURES = Object.assign({}, TABS, {
  DEEP_COMMENTING: 'deepCommenting'
});
export const FEATURES_WITHOUT_SETUP = Object.assign({}, TABS);